import { render, staticRenderFns } from "./ViewRolePermissionsComponent.vue?vue&type=template&id=16110305&scoped=true&"
import script from "./ViewRolePermissionsComponent.vue?vue&type=script&lang=ts&"
export * from "./ViewRolePermissionsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ViewRolePermissionsComponent.vue?vue&type=style&index=0&id=16110305&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16110305",
  null
  
)

export default component.exports